// Lightweight client-side error logging helper
// - Accepts optional context for extra breadcrumbs
export const logClientError = (error, info, context = {}) => {
  try {
    const payload = {
      event: 'client_error',
      message: String(error?.message || error),
      name: error?.name || 'Error',
      stack: error?.stack || null,
      componentStack: info?.componentStack || null,
      ...context,
    };
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', payload);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary:failed-log]', e);
  }
};
